import { Factory } from 'miragejs';
import faker from 'faker';

export default {
  event: Factory.extend({
    name: (i) => `${i} ${faker.lorem.sentences(1)}`,
  }),
};
